import { render, staticRenderFns } from "./PilihanChip.vue?vue&type=template&id=2693f504&scoped=true&"
import script from "./PilihanChip.vue?vue&type=script&lang=ts&"
export * from "./PilihanChip.vue?vue&type=script&lang=ts&"
import style0 from "./PilihanChip.vue?vue&type=style&index=0&id=2693f504&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2693f504",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
